import { Injectable } from '@angular/core'
import { Http, Headers, RequestOptions } from "@angular/http"
import { OrderM } from "../model/order.mobel"
import { PaymentM } from "../model/payment"
import { OrderDetailM } from "../model/order_detail.model"
import { PurchaseM } from "../model/purchase.model"
import { PurchaseDetailM } from "../model/purchase_detail.model"
import { Util } from "../util/util"

@Injectable()
export class PurchaseService {
  private order: OrderM = new OrderM();
  private payment: PaymentM = new PaymentM();

  headers = new Headers();
  options: RequestOptions

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json')
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({ headers: this.headers })
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({ headers: this.headers })
  }

  getAll(type: string, branch_id: number, detail_type: string, invReqType: string, searchStr: string, status: string, status_payment: string, seller_id: number = 0, purchase_id: number = 0, sales_id: number = 0, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc', overdueStatus = '', type2_id = 0) {
    this.reloadToken()
    return this.http.get(`/api/purchase/list?type=${type}&branch_id=${branch_id}&detail_type=${detail_type}&inv_request_type=${invReqType}&searchStr=${searchStr}&status=${status}&status_payment=${status_payment}&customer_id=${seller_id}&purchase_id=${purchase_id}&sales_id=${sales_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}&overdueStatus=${overdueStatus}&type2_id=${type2_id}`, this.options).map(res => res.json())
  }

  getProduct_old(supplier_id: number, branch_id: number, brand_id: number, type_id: number, type2_id: number, size: string, color: string, part_color: string, invReqType: string, searchStr: string, status: string, status_payment: string, customer_id: number = 0, seller_id: number = 0, sales_id: number = 0, searchDateType: string, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    this.http.get(`/api/purchase/product?seller_id=${supplier_id}&branch_id=${branch_id}&brand_id=${brand_id}&type_id=${type_id}&type2_id=${type2_id}&size=${size}&color=${color}&part_color=${part_color}&detail_type=product&inv_request_type=${invReqType}&searchStr=${searchStr}&status=${status}&status_payment=${status_payment}&customer_id=${customer_id}&sales_id=${sales_id}&searchDateType=${searchDateType}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json())
  }

  getShortInfoById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/getShortInfoById/${id}`, this.options).map(res => res.json())
  }

  getProduct(searchObj) {
    this.reloadToken()
    return this.http.post(`/api/purchase/product-list`, searchObj, this.options).map(res => res.json())
  }

  getAttrIndex(searchObj) {
    this.reloadToken()
    return this.http.post(`/api/purchase/attrIndex`, searchObj, this.options).map(res => res.json())
  }

  getProductLog(id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/product/log/${id}`, this.options).map(res => res.json())
  }

  getDetail(bill_no: string) {
    this.reloadToken()
    return this.http.get(`/api/purchase/detail/${bill_no}`, this.options).map(res => res.json())
  }

  getDetailById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/detail/${id}`, this.options).map(res => res.json())
  }

  getDetailByIdWithSearchParams(id: number, searchParams) {
    this.reloadToken()
    return this.http.post(`/api/purchase/detailWithSearchParams/${id}`, this.options, searchParams).map(res => res.json())
  }

  getDetailByOverview(search) {
    this.reloadToken()
    return this.http.post(`/api/purchase/product-overview`, search, this.options).map(res => res.json())
  }

  getOverviewSummary(search) {
    this.reloadToken()
    return this.http.post(`/api/purchase/product-overview-summary`, search, this.options).map(res => res.json())
  }

  getDetailAfterSaveStockInById(id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/detail/afterSaveStockIn/${id}`, this.options).map(res => res.json())
  }

  getDetailAfterSaveStockInOverview() {
    this.reloadToken()
    return this.http.get(`/api/purchase/getDetailAfterSaveStockInOverview`, this.options).map(res => res.json())
  }

  updatePurchaseDetailOverview(details) {
    this.reloadToken()
    return this.http.put(`/api/purchase/updatePurchaseDetailOverview`, { details: details }, this.options).map(res => res.json())
  }

  getBillingInfo(no: string) {
    this.reloadToken()
    return this.http.get(`/api/purchase/detail/${no}`, this.options).map(res => res.json())
  }

  create(purchase: PurchaseM) {
    this.reloadToken()
    return this.http.post(`/api/purchase`, purchase, this.options).map(res => res.json())
  }

  update(purchase: PurchaseM) {
    this.reloadToken()
    return this.http.put(`/api/purchase/detail/${purchase.id}`, purchase, this.options).map(res => res.json())
  }

  saveStockInByBarcodeNo(purchase_id: number, barcode: string) {
    this.reloadToken()
    return this.http.put(`/api/purchase/saveStockIn`, { purchase_id: purchase_id, barcode: barcode }, this.options).map(res => res.json())
  }

  saveStockInAndBranchByBarcodeNo(barcode: string) {
    this.reloadToken()
    return this.http.put(`/api/purchase/saveStockInAndBranch`, { barcode: barcode }, this.options).map(res => res.json())
  }


  cancelStockInById(id: number) {
    this.reloadToken()
    return this.http.put(`/api/purchase/cancelStockIn/${id}`, {}, this.options).map(res => res.json())
  }

  updateStatus(purchase_id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/purchase/status/${purchase_id}/${status}`, {}, this.options).map(res => res.json())
  }

  getOrderStatusCount() {
    this.reloadToken()
    return this.http.get(`/api/purchase/getStatusCount`, this.options).map(res => res.json())
  }

  changeToType(id: number, type: string) {
    this.reloadToken()
    return this.http.put(`/api/purchase/changeToType/${id}/`, { type: type }, this.options).map(res => res.json())
  }

  updateDetail(id: number, item: PurchaseDetailM) {
    this.reloadToken()
    return this.http.put(`/api/purchase/updateDetail/${id}`, item, this.options).map(res => res.json())
  }

  updateBalance(id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/updateBalance/${id}`, this.options).map(res => res.json())
  }

  updateCost(data: any) {
    this.reloadToken()
    return this.http.put(`/api/purchase/updateCost`, { data: data }, this.options).map(res => res.json())
  }

  updateDetails(data: any) {
    this.reloadToken()
    return this.http.put(`/api/purchase/updateDetails`, { data: data }, this.options).map(res => res.json())
  }

  clearStatement(id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/clearStatement/${id}`, this.options).map(res => res.json())
  }

  getStockBeltAndShoe(type: string = "belt") {
    this.reloadToken()
    return this.http.get(`/api/purchase/getStockBeltAndShoe/${type}`, this.options).map(res => res.json())
  }

  getProductAttributes(type: string = "purchase") {
    this.reloadToken()
    return this.http.get(`/api/purchase/productAttributes/${type}`, this.options).map(res => res.json())
  }

  getBranches() {
    this.reloadToken()
    return this.http.get(`/api/purchase/branches`, this.options).map(res => res.json())
  }

  getProductInfoByBarcode(barcode: string) {
    this.reloadToken()
    return this.http.get(`/api/purchase/getProductInfoByBarcode/${barcode}`, this.options).map(res => res.json())
  }

  clearDebt(settleAmount, purchase_id) {
    this.reloadToken()
    return this.http.post(`/api/purchase/clearDebt/${purchase_id}`, { settleAmount }, this.options).map(res => res.json())
  }

  getPurchaseInfoByIds(ids: any = []) {
    this.reloadToken()
    return this.http.post(`/api/purchase/getPurchaseInfoByIds`, { ids: ids }, this.options).map(res => res.json())
  }

  changeProductFormLostToApproved(id: number) {
    this.reloadToken()
    return this.http.put(`/api/purchase/changeProductFormLostToApproved/${id}`, {}, this.options).map(res => res.json())
  }

  updateNullBarcode(purchase_id: number) {
    this.reloadToken()
    return this.http.put(`/api/purchase/updateNullBarcode/${purchase_id}`, {}, this.options).map(res => res.json())
  }

  updateBarcodeManual(barcode: string) {
    this.reloadToken()
    return this.http.get(`/api/purchase/updateBarcodeManual/${barcode}`, this.options).map(res => res.json())
  }

  takeoverConsignment(purchase_id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/takeoverConsignment/${purchase_id}`, this.options).map(res => res.json())
  }

  takeoverConsignmentWithDetail(purchase_id: number, purchase_detail_id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/takeoverConsignmentWithDetail/${purchase_id}/${purchase_detail_id}`, this.options).map(res => res.json())
  }

  calPawnInterest(purchase_id: number) {
    this.reloadToken()
    return this.http.get(`/api/purchase/calPawnInterest/${purchase_id}`, this.options).map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/services/purchase.service.ts